import React from 'react';

import { T8y } from 'ui';

export const Meta8 = () => {
  return (
    <div>
      <T8y as="h1" center bold mb2>
        8 Yard Skip
      </T8y>
      <T8y as="h2" center mb2>
        Ideal Skips for Large Domestic and Commercial Projects
      </T8y>
      <T8y as="p" center mb3>
        The 8-yard skip is perfect for larger domestic clearances and commercial
        projects. Its generous size can handle significant amounts of waste,
        making it a popular choice for professionals undertaking substantial
        work.
      </T8y>
      <T8y as="h3" center mb2>
        Suitable Projects for an 8 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Large-scale home renovations <br />
        Office cleanouts and refurbishments <br />
        Construction site waste disposal <br />
        Shop fittings and retail refits <br />
      </T8y>
      <T8y as="h3" center mb2>
        Why Choose an 8 Yard Skip?
      </T8y>
      <T8y as="p" center mb3>
        Large-scale home renovations <br />
        Office cleanouts and refurbishments <br />
        Construction site waste disposal <br />
        Shop fittings and retail refits <br />
      </T8y>
      <T8y as="h3" center mb2>
        Why Choose an 8 Yard Skip?
      </T8y>
      <T8y as="p" center mb3>
        Ample Capacity: Reduces the need for multiple skip hires. <br />
        Time-Saving: Fewer waste removal trips enhance project efficiency.
        <br />
        Cost-Effective: Competitive pricing for substantial waste volumes.
        <br />
        Professional Service: Reliable delivery and pickup schedules. <br />
      </T8y>
      <T8y as="h4" center mb2>
        Booking Your 8 Yard Skip
      </T8y>
      <T8y as="p" center mb5>
        Contact our customer service team or use our online booking system.
        We'll coordinate delivery and pick-up times that align with your project
        schedule, ensuring seamless waste management.
      </T8y>
    </div>
  );
};
